import React, { useState, useEffect } from 'react'
import './Profile.css'
import Spinner from '../../utilities/spinner/Spinner'
import ChangePasswordButton from '../../component/profile/ChangePasswordButton'
import ImageSection from '../../component/profile/ImageSection'
import EditProfileForm from '../../component/profile/EditProfileForm'
//Redux
import { setTitle } from '../../redux'
import { useSelector, useDispatch } from 'react-redux'

function ViewMyProfile() {
  const user = useSelector((state) => state.user)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setTitle('My Profile'))
  }, [])

  let profileMarkup =
    Object.keys(user.credentials).length > 0 ? (
      <div className='profile-container'>
        <div className='profile-left-side '>
          <EditProfileForm />
        </div>
        <div className='profile-right-side'>
          <ImageSection />
          <ChangePasswordButton email={user.credentials.email} />
          {/* <div className='profile-logs'>Login logs</div> */}
        </div>
      </div>
    ) : (
      <Spinner />
    )

  return profileMarkup
}

export default ViewMyProfile
